// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerIcon {
  font-size: 20px;
}

.netWallet {
  width: 100%;
  display: flex;
  margin-top: 20px;
  margin-bottom: 60px;
  justify-content: space-between;
}

.step-container {
  box-sizing: border-box;
  min-width: 0px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.twoFactor-main {
  width: 100%;
}

.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: '';
  border-bottom: 3px solid #eaecef;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: '';
  border-bottom: 3px solid #eaecef;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eaecef;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #2172e5;
  color: #fff;
}

.stepper-item.completed::after {
  position: absolute;
  content: '';
  border-bottom: 3px solid #2172e5;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

.step-title {
  box-sizing: border-box;
  margin: 40px 0px 24px;
  min-width: 0px;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.authenticatorSelection {
  background-color: rgb(245, 245, 245);
  color: rgb(30, 35, 41);
  padding: 8px 16px;
  margin-right: 0px;
  border-radius: 2px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 20px;
}

.playStore {
  box-sizing: border-box;
  min-width: 0px;
  border-radius: 4px;
  text-align: center;
  padding: 24px;
  cursor: pointer;
}

.playStore svg {
  width: 80px;
}

.download-from {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgb(112, 122, 138);
}

.appStoreName {
  margin: 4px 0px 0px;
  min-width: 0px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
}

.setupInstruction {
  box-sizing: border-box;
  margin: 24px 0px 0px;
  min-width: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.setupInstruction svg {
  color: #929aa5;
  width: 1.5em;
}

.setupAuth {
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  line-height: 20px;
  color: rgb(71, 77, 87);
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.primaryBtn {
  margin: 24px 0px 0px;
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  outline: none;
  padding: 12px 24px;
  line-height: 24px;
  min-width: 80px;
  word-break: keep-all;
  color: #fff;
  border-radius: 4px;
  min-height: 24px;
  border: none;
  background-color: #2172e5;
  width: 100%;
}

.qr-main {
  text-align: center;
}

.qrCode {
  box-shadow: rgb(24 26 32 / 10%) 0px 0px 1px, rgb(71 77 87 / 4%) 0px 3px 6px, rgb(24 26 32 / 4%) 0px 1px 2px;
  border-radius: 4px;
  width: 150px;
  height: 150px;
  margin: 0 auto;
  background-color: rgb(255, 255, 255);
}

.qrCode img {
  width: 100%;
  height: 100%;
}

.qrId {
  margin: 0.8rem;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

.stepInstruction {
  font-weight: 400;
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
  color: rgb(112, 122, 138);
}

.prevNext {
  display: flex;
}

.prevBtn {
  margin: 40px 0px 0px;
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  outline: none;
  padding: 12px 24px;
  line-height: 24px;
  min-width: 80px;
  word-break: keep-all;
  color: rgb(30, 35, 41);
  border-radius: 4px;
  min-height: 24px;
  border: none;
  background-color: rgb(234, 236, 239);
  width: 100%;
}

.nextBtn {
  margin: 40px 0px 0px 16px;
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  outline: none;
  padding: 12px 24px;
  line-height: 24px;
  min-width: 80px;
  word-break: keep-all;
  color: #fff;
  border-radius: 4px;
  min-height: 24px;
  border: none;
  background-image: none;
  background-color: #2172e5;
  width: 100%;
}

.nextBtn[disabled]*
{
  display: none !important;
  background-color: gray !important;
}

.nextBtnTwo {
  margin: 40px 0px 0px 0px;
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  outline: none;
  padding: 12px 24px;
  line-height: 24px;
  min-width: 80px;
  word-break: keep-all;
  color: #fff;
  border-radius: 4px;
  min-height: 24px;
  border: none;
  background-image: none;
  background-color: #2172e5;
}

.inputWithButton {
  position: relative;
  height: 100px;
  width: 200px;
}

.inputWithButton input {
  width: 70%;
  height: 25px;
  padding-right: 60px;
}

.inputWithButton button {
  position: absolute;
  right: 0;
  top: 5px;
}

.custom-search {
  position: relative;
}

.twofa input::-webkit-outer-spin-button,
.twofa input::-webkit-inner-spin-button{
  -webkit-appearance: none;
  margin: 0;
}

.custom-search-input {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 100px 15px 13px;
  line-height: 1;
  box-sizing: border-box;
  outline: none;
  /* background: transparent; */
}

.custom-search-botton {
  position: absolute;
  right: 3px;
  top: 3px;
  bottom: 3px;
  border: 0;
  background: transparent;
  color: #2172e5;
  outline: none;
  margin: 0;
  padding: 0 10px;
  z-index: 2;
  cursor: pointer;
  font-weight: bold;
}

.custom-lable {
  font-size: 14px;
  line-height: 32px;
  color: rgb(71, 77, 87);
}

.validation {
  font-size: 12px;
  margin-top: 4px;
  line-height: 16px;
  color: rgb(112, 122, 138);
}

.inbutContainer {
  margin-bottom: 15px;
}

.securityUnavailable {
  color: #2172e5;
  text-decoration: none;
}

.enableDisableSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ed-btn {
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  outline: none;
  padding: 12px 24px;
  min-width: 80px;
  word-break: keep-all;
  color: rgb(30, 35, 41);
  border-radius: 4px;
  height: 48px;
  margin-left: 5px;
  border: none;
  background-color: rgb(234, 236, 239);
}

.completed {
  text-align: center;
}

.tokenValidation {
  font-size: 12px;
  margin: 0px;
  color: red;
}

.verify-token {
  display: flex;
  justify-content: center;
}

.account-icon {
  font-size: 25px;
  border: 1px solid grey;
  padding: 0.25rem;
  border-radius: 6px;
}

.account-text {
  position: absolute;
  top: 24px;
  transform: translateX(-50%);
  font-size: 12px;
  padding: 5px;
  left: 13px;
}

.account-icon:hover {
  box-shadow: 0px 1px 4px 1px #ffffff96;
}

.rmCard {
  background: #fff;
  border-radius: 15px;
  margin-bottom: 30px;
  padding: 20px;
  box-shadow: 0px 0px 20px rgb(55 55 89 / 10%);
}

.rmHeading {
  margin-bottom: 40px;
  color: #8691b4;
}

.rmTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rmTitle h5 {
  color: #8691b4;
}

.rmInfo {
  display: flex;
  margin-top: 15px;
  align-items: center;
  justify-content: space-between;
}

.rmAccordian .accordion-button:focus {
  box-shadow: none;
}

.rmAccordian .accordion-button:not(.collapsed) {
  box-shadow: none;
  background-color: transparent;
}

.rmAccordian .accordion-item {
  border: none;
  background-color: transparent;
}

.rmAccordian .accordion-button {
  padding-left: 0px;
  padding-right: 0px;
  color: #2577fa;
  background-color: transparent;
}

.rmAccordian .accordion-body {
  padding-left: 0px;
  padding-right: 0px;
  color: #2577fa;
}

.mainTitle {
  font-size: 60px;
  color: #2577fa;
  font-weight: 700;
  line-height: 1;
}

.mainDesc {
  font-size: 20px;
  font-weight: 600;
}

.resMob .offcanvas {
  background-color: transparent;
}

.resMob .btn-close {
  color: #2577fa;
}

.modal-backdrop {
  display: none;
}

.navbar-toggler:focus {
  box-shadow: none;
}

.socialMedia {
  position: absolute !important;
  width: 85%;
  bottom: 10px;
}

.copyRight {
  font-size: 13px;
  color: #e6e6e6;
}

.videoModal {
  height: 340px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.5);
}

.tradingView iframe {
  border-radius: 24px;
  /* height: 330px !important; */
}

.faq-accordian .accordion {
  box-shadow: 0px 13px 23px -13px rgba(0, 0, 0, 0.5);
  background-color: transparent;
  margin: auto;
  margin-top: 50px;
}

.title {
  height: 30px;
  width: 400px;
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffddcc;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: left;
  line-height: 2;
  font-weight: lighter;
  position: relative;
  padding: 10px;
  z-index: 2000;
  border-radius: 4px;
  margin-top: 2px;
  transition: all 0.2s ease-in;
}

.title-text {
  margin-left: 10px;
}

.title:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}

.title:active {
  background-color: rgba(0, 0, 0, 0.55);
}

.content {
  height: 30px;
  width: 420px;
  background-color: transparent;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  text-align: center;
  position: relative;
  z-index: 1000;
  margin-top: -30px;
  text-align: left;
  transition: all 200ms cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.content-open {
  margin-top: 0px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.1);
  transition: all 350ms cubic-bezier(0.08, 1.09, 0.32, 1.275);
}

.content-text {
  padding: 15px;
  visibility: hidden;
  opacity: 0;
  overflow: auto;
  transition: all 0.2s ease-in;
}

.content-text-open {
  visibility: visible;
  opacity: 1;
  transition: all 0.8s ease-in;
}

.fa-angle-down {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.6s cubic-bezier(0.08, 1.09, 0.32, 1.275);
}

.fa-rotate-180 {
  color: rgba(255, 255, 255, 1);
}

.arrow-wrapper {
  position: absolute;
  margin-left: 375px;
}

/* .accordion-item .accordion-collapse {
  transition: all 200ms cubic-bezier(0.600, -0.280, 0.735, 0.045);
}

.accordion-item .show {
  transition: all 350ms cubic-bezier(0.080, 1.090, 0.320, 1.275);
} */

.accordion-body {
  margin-top: 5px;
  color: black;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease-in;
}

.accordion-item .show .accordion-body {
  visibility: visible;
  opacity: 1;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  transition: all 0.8s ease-in;
}

.accordion-item {
  margin-bottom: 5px;
  border-radius: 0px;
  border: none !important;
  background-color: transparent !important;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  color: #ffffff;
  background-color: #2577fa;
  border-radius: 10px !important;
}

.accordion-item .accordion-button {
  border-radius: 10px !important;
}

.accordion {
  box-shadow: none !important;
}

@media screen and (max-width: 768px) {
  .netWallet {
    margin-top: 80px;
    margin-bottom: 10px;
  }

  .resMob .offcanvas-end {
    width: 240px;
  }

  .mainTitle {
    font-size: 35px;
  }
}

.txdn {
  text-decoration: none;
}

.para {
  color: aqua;
  background-color: black;
}

.lockLiquidityDate {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 15px 15px 15px;
}

.material-icons.orange600 { color: #FB8C00; }`, "",{"version":3,"sources":["webpack://./src/pages/Style/Style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;;EAEP;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,aAAa;EAEb,mBAAmB;EAEnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EAEpB,mBAAmB;EAEnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2GAA2G;EAC3G,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EAEpB,mBAAmB;EAEnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EAEpB,mBAAmB;EAEnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EAEpB,mBAAmB;EAEnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,SAAS;EACT,eAAe;EACf,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EAEpB,mBAAmB;EAEnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,4BAA4B,cAAc,EAAE","sourcesContent":[".headerIcon {\n  font-size: 20px;\n}\n\n.netWallet {\n  width: 100%;\n  display: flex;\n  margin-top: 20px;\n  margin-bottom: 60px;\n  justify-content: space-between;\n}\n\n.step-container {\n  box-sizing: border-box;\n  min-width: 0px;\n  width: 100%;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.twoFactor-main {\n  width: 100%;\n}\n\n.stepper-wrapper {\n  margin-top: auto;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.stepper-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n\n  @media (max-width: 768px) {\n    font-size: 12px;\n  }\n}\n\n.stepper-item::before {\n  position: absolute;\n  content: '';\n  border-bottom: 3px solid #eaecef;\n  width: 100%;\n  top: 20px;\n  left: -50%;\n  z-index: 2;\n}\n\n.stepper-item::after {\n  position: absolute;\n  content: '';\n  border-bottom: 3px solid #eaecef;\n  width: 100%;\n  top: 20px;\n  left: 50%;\n  z-index: 2;\n}\n\n.stepper-item .step-counter {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #eaecef;\n  margin-bottom: 6px;\n}\n\n.stepper-item.active {\n  font-weight: bold;\n}\n\n.stepper-item.completed .step-counter {\n  background-color: #2172e5;\n  color: #fff;\n}\n\n.stepper-item.completed::after {\n  position: absolute;\n  content: '';\n  border-bottom: 3px solid #2172e5;\n  width: 100%;\n  top: 20px;\n  left: 50%;\n  z-index: 3;\n}\n\n.stepper-item:first-child::before {\n  content: none;\n}\n\n.stepper-item:last-child::after {\n  content: none;\n}\n\n.step-title {\n  box-sizing: border-box;\n  margin: 40px 0px 24px;\n  min-width: 0px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.authenticatorSelection {\n  background-color: rgb(245, 245, 245);\n  color: rgb(30, 35, 41);\n  padding: 8px 16px;\n  margin-right: 0px;\n  border-radius: 2px;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.playStore {\n  box-sizing: border-box;\n  min-width: 0px;\n  border-radius: 4px;\n  text-align: center;\n  padding: 24px;\n  cursor: pointer;\n}\n\n.playStore svg {\n  width: 80px;\n}\n\n.download-from {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgb(112, 122, 138);\n}\n\n.appStoreName {\n  margin: 4px 0px 0px;\n  min-width: 0px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n}\n\n.setupInstruction {\n  box-sizing: border-box;\n  margin: 24px 0px 0px;\n  min-width: 0px;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n}\n\n.setupInstruction svg {\n  color: #929aa5;\n  width: 1.5em;\n}\n\n.setupAuth {\n  text-align: left;\n  vertical-align: middle;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgb(71, 77, 87);\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.primaryBtn {\n  margin: 24px 0px 0px;\n  appearance: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  padding: 12px 24px;\n  line-height: 24px;\n  min-width: 80px;\n  word-break: keep-all;\n  color: #fff;\n  border-radius: 4px;\n  min-height: 24px;\n  border: none;\n  background-color: #2172e5;\n  width: 100%;\n}\n\n.qr-main {\n  text-align: center;\n}\n\n.qrCode {\n  box-shadow: rgb(24 26 32 / 10%) 0px 0px 1px, rgb(71 77 87 / 4%) 0px 3px 6px, rgb(24 26 32 / 4%) 0px 1px 2px;\n  border-radius: 4px;\n  width: 150px;\n  height: 150px;\n  margin: 0 auto;\n  background-color: rgb(255, 255, 255);\n}\n\n.qrCode img {\n  width: 100%;\n  height: 100%;\n}\n\n.qrId {\n  margin: 0.8rem;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.stepInstruction {\n  font-weight: 400;\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgb(112, 122, 138);\n}\n\n.prevNext {\n  display: flex;\n}\n\n.prevBtn {\n  margin: 40px 0px 0px;\n  appearance: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  padding: 12px 24px;\n  line-height: 24px;\n  min-width: 80px;\n  word-break: keep-all;\n  color: rgb(30, 35, 41);\n  border-radius: 4px;\n  min-height: 24px;\n  border: none;\n  background-color: rgb(234, 236, 239);\n  width: 100%;\n}\n\n.nextBtn {\n  margin: 40px 0px 0px 16px;\n  appearance: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  padding: 12px 24px;\n  line-height: 24px;\n  min-width: 80px;\n  word-break: keep-all;\n  color: #fff;\n  border-radius: 4px;\n  min-height: 24px;\n  border: none;\n  background-image: none;\n  background-color: #2172e5;\n  width: 100%;\n}\n\n.nextBtn[disabled]*\n{\n  display: none !important;\n  background-color: gray !important;\n}\n\n.nextBtnTwo {\n  margin: 40px 0px 0px 0px;\n  appearance: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  padding: 12px 24px;\n  line-height: 24px;\n  min-width: 80px;\n  word-break: keep-all;\n  color: #fff;\n  border-radius: 4px;\n  min-height: 24px;\n  border: none;\n  background-image: none;\n  background-color: #2172e5;\n}\n\n.inputWithButton {\n  position: relative;\n  height: 100px;\n  width: 200px;\n}\n\n.inputWithButton input {\n  width: 70%;\n  height: 25px;\n  padding-right: 60px;\n}\n\n.inputWithButton button {\n  position: absolute;\n  right: 0;\n  top: 5px;\n}\n\n.custom-search {\n  position: relative;\n}\n\n.twofa input::-webkit-outer-spin-button,\n.twofa input::-webkit-inner-spin-button{\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.custom-search-input {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 15px 100px 15px 13px;\n  line-height: 1;\n  box-sizing: border-box;\n  outline: none;\n  /* background: transparent; */\n}\n\n.custom-search-botton {\n  position: absolute;\n  right: 3px;\n  top: 3px;\n  bottom: 3px;\n  border: 0;\n  background: transparent;\n  color: #2172e5;\n  outline: none;\n  margin: 0;\n  padding: 0 10px;\n  z-index: 2;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.custom-lable {\n  font-size: 14px;\n  line-height: 32px;\n  color: rgb(71, 77, 87);\n}\n\n.validation {\n  font-size: 12px;\n  margin-top: 4px;\n  line-height: 16px;\n  color: rgb(112, 122, 138);\n}\n\n.inbutContainer {\n  margin-bottom: 15px;\n}\n\n.securityUnavailable {\n  color: #2172e5;\n  text-decoration: none;\n}\n\n.enableDisableSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ed-btn {\n  appearance: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-family: inherit;\n  font-weight: 500;\n  text-align: center;\n  text-decoration: none;\n  outline: none;\n  padding: 12px 24px;\n  min-width: 80px;\n  word-break: keep-all;\n  color: rgb(30, 35, 41);\n  border-radius: 4px;\n  height: 48px;\n  margin-left: 5px;\n  border: none;\n  background-color: rgb(234, 236, 239);\n}\n\n.completed {\n  text-align: center;\n}\n\n.tokenValidation {\n  font-size: 12px;\n  margin: 0px;\n  color: red;\n}\n\n.verify-token {\n  display: flex;\n  justify-content: center;\n}\n\n.account-icon {\n  font-size: 25px;\n  border: 1px solid grey;\n  padding: 0.25rem;\n  border-radius: 6px;\n}\n\n.account-text {\n  position: absolute;\n  top: 24px;\n  transform: translateX(-50%);\n  font-size: 12px;\n  padding: 5px;\n  left: 13px;\n}\n\n.account-icon:hover {\n  box-shadow: 0px 1px 4px 1px #ffffff96;\n}\n\n.rmCard {\n  background: #fff;\n  border-radius: 15px;\n  margin-bottom: 30px;\n  padding: 20px;\n  box-shadow: 0px 0px 20px rgb(55 55 89 / 10%);\n}\n\n.rmHeading {\n  margin-bottom: 40px;\n  color: #8691b4;\n}\n\n.rmTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.rmTitle h5 {\n  color: #8691b4;\n}\n\n.rmInfo {\n  display: flex;\n  margin-top: 15px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.rmAccordian .accordion-button:focus {\n  box-shadow: none;\n}\n\n.rmAccordian .accordion-button:not(.collapsed) {\n  box-shadow: none;\n  background-color: transparent;\n}\n\n.rmAccordian .accordion-item {\n  border: none;\n  background-color: transparent;\n}\n\n.rmAccordian .accordion-button {\n  padding-left: 0px;\n  padding-right: 0px;\n  color: #2577fa;\n  background-color: transparent;\n}\n\n.rmAccordian .accordion-body {\n  padding-left: 0px;\n  padding-right: 0px;\n  color: #2577fa;\n}\n\n.mainTitle {\n  font-size: 60px;\n  color: #2577fa;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.mainDesc {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.resMob .offcanvas {\n  background-color: transparent;\n}\n\n.resMob .btn-close {\n  color: #2577fa;\n}\n\n.modal-backdrop {\n  display: none;\n}\n\n.navbar-toggler:focus {\n  box-shadow: none;\n}\n\n.socialMedia {\n  position: absolute !important;\n  width: 85%;\n  bottom: 10px;\n}\n\n.copyRight {\n  font-size: 13px;\n  color: #e6e6e6;\n}\n\n.videoModal {\n  height: 340px;\n  border-radius: 20px;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.tradingView iframe {\n  border-radius: 24px;\n  /* height: 330px !important; */\n}\n\n.faq-accordian .accordion {\n  box-shadow: 0px 13px 23px -13px rgba(0, 0, 0, 0.5);\n  background-color: transparent;\n  margin: auto;\n  margin-top: 50px;\n}\n\n.title {\n  height: 30px;\n  width: 400px;\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #ffddcc;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: left;\n  line-height: 2;\n  font-weight: lighter;\n  position: relative;\n  padding: 10px;\n  z-index: 2000;\n  border-radius: 4px;\n  margin-top: 2px;\n  transition: all 0.2s ease-in;\n}\n\n.title-text {\n  margin-left: 10px;\n}\n\n.title:hover {\n  cursor: pointer;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.title:active {\n  background-color: rgba(0, 0, 0, 0.55);\n}\n\n.content {\n  height: 30px;\n  width: 420px;\n  background-color: transparent;\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  text-align: center;\n  position: relative;\n  z-index: 1000;\n  margin-top: -30px;\n  text-align: left;\n  transition: all 200ms cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n.content-open {\n  margin-top: 0px;\n  height: 200px;\n  background-color: rgba(0, 0, 0, 0.1);\n  transition: all 350ms cubic-bezier(0.08, 1.09, 0.32, 1.275);\n}\n\n.content-text {\n  padding: 15px;\n  visibility: hidden;\n  opacity: 0;\n  overflow: auto;\n  transition: all 0.2s ease-in;\n}\n\n.content-text-open {\n  visibility: visible;\n  opacity: 1;\n  transition: all 0.8s ease-in;\n}\n\n.fa-angle-down {\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.5);\n  transition: all 0.6s cubic-bezier(0.08, 1.09, 0.32, 1.275);\n}\n\n.fa-rotate-180 {\n  color: rgba(255, 255, 255, 1);\n}\n\n.arrow-wrapper {\n  position: absolute;\n  margin-left: 375px;\n}\n\n/* .accordion-item .accordion-collapse {\n  transition: all 200ms cubic-bezier(0.600, -0.280, 0.735, 0.045);\n}\n\n.accordion-item .show {\n  transition: all 350ms cubic-bezier(0.080, 1.090, 0.320, 1.275);\n} */\n\n.accordion-body {\n  margin-top: 5px;\n  color: black;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.2s ease-in;\n}\n\n.accordion-item .show .accordion-body {\n  visibility: visible;\n  opacity: 1;\n  border-radius: 10px;\n  background-color: rgba(0, 0, 0, 0.1);\n  transition: all 0.8s ease-in;\n}\n\n.accordion-item {\n  margin-bottom: 5px;\n  border-radius: 0px;\n  border: none !important;\n  background-color: transparent !important;\n}\n\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #ffffff;\n  background-color: #2577fa;\n  border-radius: 10px !important;\n}\n\n.accordion-item .accordion-button {\n  border-radius: 10px !important;\n}\n\n.accordion {\n  box-shadow: none !important;\n}\n\n@media screen and (max-width: 768px) {\n  .netWallet {\n    margin-top: 80px;\n    margin-bottom: 10px;\n  }\n\n  .resMob .offcanvas-end {\n    width: 240px;\n  }\n\n  .mainTitle {\n    font-size: 35px;\n  }\n}\n\n.txdn {\n  text-decoration: none;\n}\n\n.para {\n  color: aqua;\n  background-color: black;\n}\n\n.lockLiquidityDate {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 15px 15px 15px 15px;\n}\n\n.material-icons.orange600 { color: #FB8C00; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
